<template>
  <div v-if="isLoading" class="d-flex flex-fill justify-content-center loading">
    <div class="align-self-center text-center">
      <div class="spinner-grow text-light" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'global-loading-screen',
  computed: {
    isLoading () {
      return this.$store.getters.isLoading
    }
  }
}
</script>

<style scoped>
.loading {
  position: absolute;
  width: 100vw;
  height: 100vh;
  background: rgba(62, 89, 122, 0.75);
  z-index: 999;
}
</style>



// WEBPACK FOOTER //
// src/components/GlobalLoadingScreen.vue